module.exports = __webpack_public_path__ + "img/alert-triangle-icon.dff3e352.svg";